import styled from 'styled-components';

const CheckboxContainer = styled.label<any>`
  position: relative;
  cursor: pointer;
  user-select: none;
  font-size: 16px;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 8px;
`;

export default CheckboxContainer;
